module.exports = {"id":true,"itemID":true,"barCode":true,"itemLabel":true,"quantity":true,"lineStatus":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/modules/items.json
// module id = lBuE
// module chunks = 4